import React, { useEffect, useState } from "react";
import { Modal, Grid, Button } from "@mui/material";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment'
import { StorageService } from '../Commons/StorageService';
import { Redirect } from "react-router-dom";
import DateFormats from "../../utils/DateFormats";

function PromoModalTerms({ promotions, showModal, onCancel, origin, destination }) {

    const [widget, setWidget]=useState(false);

    const rsv = () =>{
        let isroundTrip = false;
        if(promotions.travelType != "sencillo"){
            isroundTrip = true;
        }

        const bookingData = {
            roundTrip: isroundTrip,
            origin: origin,
            destination: destination,
            departureDate: moment(promotions.startTravelPeriod).format(DateFormats.DATE_FORMAT),
            returnDate: isroundTrip ? moment(promotions.endTravelPeriod).format(DateFormats.DATE_FORMAT) : "",
            adults: promotions.adultCount,
            minors: promotions.childCount,
            infants: promotions.infantCount,
            is_promotion: true
        };

        StorageService.saveData(JSON.stringify(bookingData))
        setWidget(true);
        console.log(bookingData)
        
    }

    if(widget){
        return (<Redirect to="/" push={true} />)
    }
    

    return (
        <Grid container justifyContent="center" className="alertPayment" >
            <Grid container>
                <Modal
                    open={showModal}
                    onClose={onCancel}>
                    <Grid container className="promo-selection-modal">
                        <Grid item xs={12} className="alertPromo">
                            <h3><FormattedMessage id="app.promo.terms" /></h3>
                            <p>{promotions.terms}</p>
                            <Grid item xs={6} className="modal-buttons">
                                <Button variant="contained" color="secondary" onClick={rsv}>
                                    <FormattedMessage id="app.booking.widget.steps.change.continue" />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Modal>
            </Grid>
        </Grid>
    );
}

export default injectIntl(PromoModalTerms);